import './index.less';

import { Table } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getHistoryLogsByApplicationIDAndAgreementIDThunk,
  getHistoryLogsByApplicationIDThunk,
} from '../../../services/applicationService/applicationThunk';
import { AppDispatch, RootState } from '../../../store/store';
import { displayDateAndTime } from '../../../utils/datetime.util';

import type { ColumnsType } from 'antd/es/table';

interface HistoryLogTabProps {
  applicationData?: any;
  historyLogsData?: any;
}

const HistoryLogTab = ({ applicationData, historyLogsData }: HistoryLogTabProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { applicationDetails, historyLogs } = useSelector((state: RootState) => state.application);

  // Use props if available, otherwise fall back to Redux state
  const currentApplicationData = applicationData || applicationDetails?.data;
  const currentHistoryLogs = historyLogsData || historyLogs;

  const columns: ColumnsType<any> = [
    {
      title: 'Date & Time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => (text ? displayDateAndTime(text) : '-'),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Old Values',
      dataIndex: 'oldValueString',
      key: 'oldValueString',
    },
    {
      title: 'New Values',
      dataIndex: 'newValueString',
      key: 'newValueString',
    },
    {
      title: 'PIC',
      dataIndex: 'personInCharge',
      key: 'personInCharge',
      render: (text) => text || 'SYSTEM',
    },
  ];

  useEffect(() => {
    // Only run Redux dispatches if we're not using props (i.e., we're in the main page)
    if (!applicationData && !historyLogsData && currentApplicationData?.id) {
      if (currentApplicationData?.agreementId) {
        dispatch(
          getHistoryLogsByApplicationIDAndAgreementIDThunk({
            applicationId: currentApplicationData?.id,
            agreementId: currentApplicationData?.agreementId,
          })
        );
      } else {
        dispatch(
          getHistoryLogsByApplicationIDThunk({
            applicationId: currentApplicationData?.id,
          })
        );
      }
    }
  }, [
    currentApplicationData?.id,
    currentApplicationData?.agreementId,
    applicationData,
    historyLogsData,
  ]);

  return (
    <Table
      dataSource={currentHistoryLogs?.data}
      className="min-w-fit"
      columns={columns}
      bordered={true}
    />
  );
};

export default HistoryLogTab;
